var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenlocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47.2982,
    height: 47.2982,
    rx: 14.1895,
    fill: "#468C11",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6491 23.6488C24.2995 23.6488 24.8564 23.417 25.3199 22.9535C25.7826 22.4908 26.014 21.9342 26.014 21.2839C26.014 20.6335 25.7826 20.0766 25.3199 19.6131C24.8564 19.1503 24.2995 18.919 23.6491 18.919C22.9988 18.919 22.4422 19.1503 21.9795 19.6131C21.516 20.0766 21.2842 20.6335 21.2842 21.2839C21.2842 21.9342 21.516 22.4908 21.9795 22.9535C22.4422 23.417 22.9988 23.6488 23.6491 23.6488ZM23.6491 32.3398C26.0534 30.1326 27.837 28.1271 28.9997 26.3235C30.1625 24.5206 30.7438 22.9196 30.7438 21.5204C30.7438 19.3722 30.0588 17.6131 28.6887 16.2431C27.3194 14.8738 25.6396 14.1891 23.6491 14.1891C21.6586 14.1891 19.9784 14.8738 18.6083 16.2431C17.239 17.6131 16.5544 19.3722 16.5544 21.5204C16.5544 22.9196 17.1357 24.5206 18.2985 26.3235C19.4612 28.1271 21.2448 30.1326 23.6491 32.3398ZM23.6491 35.4733C20.4762 32.7734 18.1065 30.2654 16.5402 27.9494C14.973 25.6341 14.1895 23.4911 14.1895 21.5204C14.1895 18.5642 15.1405 16.2092 17.0427 14.4552C18.9441 12.7012 21.1462 11.8242 23.6491 11.8242C26.152 11.8242 28.3541 12.7012 30.2555 14.4552C32.1577 16.2092 33.1088 18.5642 33.1088 21.5204C33.1088 23.4911 32.3256 25.6341 30.7592 27.9494C29.1921 30.2654 26.822 32.7734 23.6491 35.4733Z",
    fill: "#468C11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenlocation);
export default __webpack_public_path__ + "static/media/greenlocation.e1d733c4bb5a4a722ce1bead08998e23.svg";
export { ForwardRef as ReactComponent };